import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

import ListItem from './ListItem';
import icPreferredGreen from '../assets/icons/ic_preferred_green.svg';

const LawyerItem = ({ checkVerified, headerNode, ...rest }) => {
  const check = (item) => {
    if (checkVerified) {
      return checkVerified(item);
    }
    return false;
  };
  return (
    <ListItem
      header={item => (
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          {item.lawyer_name || item.name}
          {check(item) || item.is_sub || item.verified ? <Image src={icPreferredGreen} height="15" style={{ marginLeft: '0.5em' }} /> : null}
          {headerNode}
        </div>
      )}
      subheader={item => item.firm}
      {...rest}
    />
  );
};

LawyerItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    firm: PropTypes.string,
    verified: PropTypes.number,
  }).isRequired,
  checkVerified: PropTypes.func,
  headerNode: PropTypes.node,
};

export default LawyerItem;



// WEBPACK FOOTER //
// ./src/components/LawyerItem.jsx